
import { motion } from 'framer-motion';

export default function EUProjectHero() {
  return (
    <section className="relative pt-20 sm:pt-24 pb-10 sm:pb-16 bg-[#050505] overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-48 sm:w-96 h-48 sm:h-96 bg-[#003399]/10 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-0 right-1/4 w-40 sm:w-80 h-40 sm:h-80 bg-[#FFD700]/5 rounded-full blur-[100px]"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center mb-8 sm:mb-12"
        >
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border border-[#003399]/30 bg-[#003399]/10 mb-4 sm:mb-6">
            <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
              <i className="ri-flag-line text-[#FFD700] text-xs sm:text-sm"></i>
            </div>
            <span
              className="text-[#FFD700] text-[10px] sm:text-xs font-semibold tracking-wider"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              DOFINANSOWANIE UE
            </span>
          </div>

          <h1
            className="text-white text-2xl sm:text-3xl md:text-5xl font-bold mb-4 sm:mb-6 leading-tight"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Projekty Unii<br />
            <span className="text-[#00E5FF]">Europejskiej</span>
          </h1>

          <p
            className="text-[#C0C7CF] text-sm sm:text-base md:text-lg max-w-2xl mx-auto leading-relaxed px-2"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Realizujemy projekty współfinansowane ze środków Unii Europejskiej,
            które pozwalają nam rozwijać potencjał produkcyjny i wdrażać nowoczesne technologie.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
